export default "If tax is 0% of Josh's SAV, then he can set a much higher price at no cost to himself!\n";